
import { withStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import React, { PureComponent } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { USER_NOTIFICATION_REFRESH } from '../../../../actionTypes/actionTypes';
import { drawerToggle } from '../../../../actions/appActions';
import NotificationIcon from "../../Common/Icons/NotificationIcon";
import NotifPoint from './NotificationsModal/NotifPoint';
import { withMixpanel } from '../../Common/withMixpanel';
import { hexToRGB } from '../../../../utils/hexToRGB';
import withErrorCatcher from '../../Common/withErrorCatcher';


// Apply some reset
const styles = theme => { 
    const whiteOpacity016 = hexToRGB('#FFFFFF', 0.16)
    return ({
   
    notificationPoint: {
        bottom: 30,
        left: 18
    },
   
    notificationButton: {
        margin: 0,
        paddingRight: 0,
        paddingLeft: 0,
         marginRight: 28,
         "&:hover": {
            backgroundColor: 'inherit',
          },
          
    },
  
      notificatioIconContainer: {
        height: 28,
        borderRadius: 16,
        "&:hover": {
            backgroundColor: whiteOpacity016,
          },
      }
})}


class NotificationToolbar extends PureComponent {

    showNotifications = () => {
        const { dispatch, wrapper, mixpanelTrack } = this.props;

        // if (!wrapper.notificationsOpen) this.refreshNotifications()

        // dispatch(drawerToggle({ notificationsOpen: !wrapper.notificationsOpen }))
        dispatch({type: 'TOGGLE_NOTIFICATIONS_MODAL'})
        mixpanelTrack('Opened Notification Drawer (Web)', {});
    }
    refreshNotifications = () => {
        const { notificationService, notifications, dispatch  } = this.props
  
        notificationService.getNotifications().then(newNotifications => {             
            if (newNotifications && newNotifications.length &&
                (newNotifications.length !== notifications.length ||
                    newNotifications.some(newNot => notifications.every(oldNot => oldNot.id !== newNot.id)))) {
                    dispatch({ type: USER_NOTIFICATION_REFRESH, notifications: newNotifications });
                }
        })
    }

    isFeed = (props) => {
        const { wrapper: {isFeed} } = props;
        return isFeed
    }

    componentDidUpdate(prevProps) {
        const {dispatch, wrapper} = this.props
        const isPrevFeed = this.isFeed(prevProps)
        const isNextFeed = this.isFeed(this.props)

        if(isPrevFeed === isNextFeed) return
        if(!isPrevFeed && isNextFeed && window.innerWidth >= 1680) {
            if(!wrapper.notificationsOpen) dispatch(drawerToggle({ notificationsOpen: true }))
            this.refreshNotifications()
            return
        }
    }
    componentWillReceiveProps(nextProps) {
        const {dispatch, wrapper} = this.props
        const isPrevFeed = this.isFeed(this.props)
        const isNextFeed = this.isFeed(nextProps)

        if(isPrevFeed && !isNextFeed && wrapper.notificationsOpen) {
            dispatch(drawerToggle({ notificationsOpen: false }))
            return
        }
    }

    componentDidMount() {
        const {dispatch, wrapper} = this.props

        const isNextFeed = this.isFeed(this.props)
        if(!isNextFeed) return

        if(wrapper.notificationsOpen && window.innerWidth < 1680) {
            dispatch(drawerToggle({ notificationsOpen: false }))
            return
        }
        if(!wrapper.notificationsOpen && window.innerWidth >= 1680) dispatch(drawerToggle({ notificationsOpen: true }))
        this.refreshNotifications()
    }

    render() {
        const { classes, t, lastSawNotification } = this.props;

        return (
            <Tooltip title={t('Notifications')} placement="bottom">
                <IconButton data-intrcm-id="NotificationToolbar_55kydula"  classes={{ label: classes.notificatioIconContainer, root: classes.notificationButton }} aria-label="Notifications" onClick={this.showNotifications} >
                    <NotifPoint classes={{ point: classes.notificationPoint }} lastSaw={lastSawNotification} isChatNotification={false} />
                    <NotificationIcon />
                </IconButton>
            </Tooltip>
        )
    }
}

const mapStateToProps = (state) => ({
    lastSawNotification: state.userData.profileData.lastSawNotification,
    notifications: state.userData.notifications,
    wrapper: state.wrapper,
    ...state.services
})

export default compose(withStyles(styles),
    withErrorCatcher("Notification toolbar crashed"),
    withTranslation('feedToolbar'),
    withMixpanel,
    connect(mapStateToProps))(NotificationToolbar);